import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Link, useHistory } from "react-router-dom";
import ActionLog from '../../models/ActionLog';
import Wav from '../../models/Wav';
import User from '../../models/User';
import { ActionLogType } from '../../models/ActionLogType';
import moment from 'moment';
import Property from '../../models/Property';
import PropertyList from '../../models/PropertyList';
import { ImSpinner3 } from 'react-icons/im';
import Company from '../../models/Company';
import { Card, Button, Modal, Popover } from 'react-bootstrap';
import { FcInspection, FcTimeline, FcLibrary, FcBusinesswoman, FcImport, FcServices, FcDocument, FcFactoryBreakdown, FcElectricalSensor, FcStatistics, FcDataSheet, FcCheckmark, FcPackage, FcCableRelease, FcSettings } from 'react-icons/fc';

import { FaChevronLeft, FaMapPin, FaMapMarkerAlt, FaExclamationTriangle } from 'react-icons/fa';
import DataTable from 'react-data-table-component';
import { useAuth } from '../../context/AuthContext';
import { GOOGLEMAP_GEOCODING_API_KEY, GOOGLEMAP_API_KEY } from '../../constants/Constants';
import _ from 'lodash';
import { OverlayTrigger, Overlay, Tooltip, Dropdown } from 'react-bootstrap';
import { EvaluationMark } from './EvaluationMark';
import Utils from '../../common/Utils';
import { IoMdPin } from 'react-icons/io';
import GoogleMapReact from 'google-map-react';
import { ProvideFilterContext, useFilterContext } from "../../context/SharedFilterContext";
import PropertyCard from './PropertyCard';
import ViewportPropertyCard from './PropertyCardViewport';
import UserPanel from './UserPanel';
import MetabasePanel from './MetabasePanel';
import QueryPanel from './QueryPanel';
import ViewServiceTechAtCompanyPanel from './ViewServiceTechAtCompanyPanel';
import ViewMSIUsersAggregatePanel from './ViewMSIUsersAggregatePanel';
import StatusBar from './StatusBar';
import Check from '../../models/Check';
import InspectionWorkOrdersSection from './InspectionWorkOrdersSection';

import AnalyticsCountPanel from './AnalyticsCountPanel';
import SoundDatabasePanel from './SoundDatabasePanel';
import WorkOrders from '../../models/WorkOrders';

import Geocode from "react-geocode";
import DatePicker from 'react-date-picker';
import pLimit from 'p-limit';

Geocode.setApiKey(GOOGLEMAP_GEOCODING_API_KEY);
Geocode.setLanguage("en");
Geocode.setLocationType("ROOFTOP");

const PropertyActivityGrid = (props) => {
  const {
    hideDateSelector,
    hideStartDate,
    hideEndDate,
    hideAnalysisColors,
    noResultsMessage,
    title,
    submitPath,
    hideMap,
    isInspectionPage,
    isAnalyticsPage,
    enableViewModeFiltering, // New prop for clean separation of view mode filtering
    hideStructureInfo,
    hideInspectionInfo,
    hideMapLocation,
    hideReportInfo,
    sortByReports,
    filterByReports,
    additionalButtons,
  } = props;

  const history = useHistory();

  const {
    startDate: sharedStartDate,
    endDate: sharedEndDate,
    setStartDate: setSharedStartDate,
    setEndDate: setSharedEndDate,
    defaultStartDate,
    defaultEndDate,
    inspectionViewMode,
    setInspectionViewMode,
    selectedPropertyList
  } = useFilterContext();

  const {
    user,
    isSuperAdmin,
    isCustomerTechOrHigher,
    isLimitedAdminOrHigher,
    isAdminOrHigher,
    isSubdomainAdminOrHigher,
  } = useAuth();


  const [loading, setLoading] = useState(props.loading);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [loadingMsi, setLoadingMsi] = useState(false);

  const [propertyNameFilter, setPropertyNameFilter] = useState("");
  const [propertyActivityHistory, setPropertyList] = useState([]);
  const [dataToRender, setDataToRender] = useState([]);
  const [loadMore, setLoadMore] = useState(() => () => { });
  const [hasMoreItems, setHasMoreItems] = useState(true);

  const loadMoreRef = useRef(null);

  const [totalMsiInspectionsState, setTotalMsiInspections] = useState(0);
  const [totalChecks, setTotalChecks] = useState(0);
  const [totalMsiDevices, setTotalMsiDevices] = useState(0);
  const [totalUniqueUsers, setTotalUniqueUsers] = useState(0);

  const [showMap, setShowMap] = useState(false);

  const [mapLat, setMapLat] = useState(35.73083320925414);
  const [mapLng, setMapLng] = useState(-83.72437148505048);
  const [mapZoom, setMapZoom] = useState(7);
  const defaultLat = 35.73083320925414; 
  const defaultLng = -83.72437148505048;
  const defaultZoom = 6; 
  const initialZoomLevel = 6; 

  const [startDate, setStartDateRaw] = useState(sharedStartDate);
  const [endDate, setEndDateRaw] = useState(sharedEndDate);

  // Debounce both dates together as a single key to prevent race conditions
  // when both dates change simultaneously (e.g., switching from "This Year" to "Last Year")
  const debouncedDateKey = Utils.useDebounce(`${startDate}_${endDate}`, 1000);

  // Sync shared context changes to local state (for TopNavBar date range updates)
  useEffect(() => {
    setStartDateRaw(sharedStartDate);
    setEndDateRaw(sharedEndDate);
  }, [sharedStartDate, sharedEndDate]);

  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const [propertySearchTrigger, setPropertySearchTrigger] = useState(0);

  const [loadingFavorites, setLoadingFavorites] = useState(false);
  const [favoritesLoadingProgress, setFavoritesLoadingProgress] = useState({
    currentChunk: 0,
    totalChunks: 0,
    loadedCount: 0,
    totalCount: 0
  });

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (e.target.placeholder === 'Name' || e.target.placeholder === 'Search disabled') {
        const newStart = moment(defaultEndDate).subtract(1, 'year').endOf("day").format("YYYY-MM-DD");
        const newEnd = defaultEndDate;
        setStartDateRaw(newStart);
        setEndDateRaw(newEnd);
        setSharedStartDate(newStart);
        setSharedEndDate(newEnd);
        setPropertySearchTrigger(prev => prev + 1);
      }
    }
  };

  // Property status filter (active / inactive / pending / not set). Applied
  // client-side to the loaded cards; 'all' leaves the list untouched.
  const [statusFilter, setStatusFilter] = useState('all');
  const matchesStatusFilter = (property) => {
    if (statusFilter === 'all') return true;
    if (statusFilter === 'none') return !property.status;
    return property.status === statusFilter;
  };

  const setSelectedPropertyResult = async (property) => {
    if (property) {
      console.log({ submitPath })
      history.push(`${submitPath}/${property.uuid}`)
    }
  }

  const queryPropertiesGeneric = async (abortSignal, searchId, pageSize = 50) => {
    // Check if request was cancelled before making API call
    if (abortSignal?.aborted) {
      console.log(`🚫 QueryPropertiesGeneric [${searchId}] aborted before API call`);
      throw new DOMException('Request was cancelled', 'AbortError');
    }

    // Stage 1: Get lightweight property data (uuid + sort fields) via paginated direct query
    console.log(`📡 QueryPropertiesGeneric [${searchId}] fetching lightweight property data`);
    const lightweightProperties = await Property.getPropertySortDataForCompany(
      user?.company?.id,
      propertyNameFilter,
      abortSignal,
      searchId
    );

    console.log(`📡 QueryPropertiesGeneric [${searchId}] found ${lightweightProperties.length} properties, sorting`);

    // Apply the same sorting/filtering logic as before
    let sortedProperties = lightweightProperties;
    if (!sortByReports) {
      sortedProperties = _.sortBy(_.sortBy(sortedProperties, o => !isNaN(parseInt(o.name)), 'name'));
    }
    if (filterByReports) {
      sortedProperties = sortedProperties.filter(property => property.lastReportRun && moment(property.lastReportRun.created_at).isAfter(startDate));
    }
    sortedProperties = _.orderBy(sortedProperties, [
      property => sortByReports
        ? (property.lastReportRun ? moment(property.lastReportRun.created_at).unix() : -1)
        : moment(property.updated_at).unix(),
    ], ['desc', 'desc']);

    // Extract sorted UUIDs for batch detail fetching
    const sortedUuids = sortedProperties.map(p => p.uuid);

    // Stage 2: Batch loading - return a function that fetches detail data in pages
    let nextIndex = 0;

    const loadAdditionalProperties = async () => {
      setIsLoadingMore(true);

      if (abortSignal?.aborted) {
        setIsLoadingMore(false);
        throw new DOMException('Request was cancelled', 'AbortError');
      }

      if (nextIndex === 0) {
        setPropertyList([]);
      }

      const currentBatchUuids = sortedUuids.slice(nextIndex, nextIndex + pageSize);
      nextIndex += pageSize;

      if (sortedUuids.length > 100) {
        console.log(`📦 LoadAdditionalProperties (generic) [${searchId}] loading batch ${nextIndex/pageSize} of ${Math.ceil(sortedUuids.length/pageSize)} (${currentBatchUuids.length} properties)`);
      }

      // Fetch detail data for this batch
      const batchData = await Property.getCardDataForEditPage(
        currentBatchUuids,
        user?.id,
        abortSignal,
        searchId
      );

      // Sort batch results to match the sorted UUID order
      const orderedBatch = currentBatchUuids
        .map(uuid => batchData.find(p => p.uuid === uuid))
        .filter(p => p !== null && p !== undefined);

      setPropertyList(prevList => {
        const uniqueUuids = [...new Set([...prevList, ...orderedBatch].map(item => item.uuid))];
        return uniqueUuids.map(uuid => prevList.find(item => item.uuid === uuid) || orderedBatch.find(item => item.uuid === uuid));
      });

      if (nextIndex >= sortedUuids.length) {
        setHasMoreItems(false);
      }
      setIsLoadingMore(false);
    };

    return loadAdditionalProperties;
  }

    const queryProperties = async (userId, propertyNameFilter, propertyFilterFunction, pageSize = 50, abortSignal, searchId) => {   
    // Convert local dates to UTC range that covers the entire local day
    const utcStartDate = moment(startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
    const utcEndDate = moment(endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
    
    // Check if request was cancelled before making expensive API call
    if (abortSignal?.aborted) {
      // console.log(`🚫 QueryProperties [${searchId}] aborted before API call`);
      throw new DOMException('Request was cancelled', 'AbortError');
    }

    // Use lightweight paginated query to get sort data (avoids AppSync "Transformation too large" error)
    const propertiesSortData = await Property.getPropertySortDataForInspections(
      user?.company?.id,
      propertyNameFilter,
      utcStartDate,
      utcEndDate,
      abortSignal,
      searchId
    );

    console.log("This is from queryProperties, before we sort propertiesSortData", propertiesSortData);

    const sortedProperties = (propertiesSortData || [])
      .sort((a, b) => {
        const lastUploadA = a.last_upload_at ? moment(a.last_upload_at) : moment(0);
        const lastUploadB = b.last_upload_at ? moment(b.last_upload_at) : moment(0);

        const firstCheckCreatedA = a.checks?.edges[0]?.node?.created_at ? moment(a.checks.edges[0].node.created_at) : moment(0);
        const firstCheckCreatedB = b.checks?.edges[0]?.node?.created_at ? moment(b.checks.edges[0].node.created_at) : moment(0);

        const mostRecentA = moment.max(lastUploadA, firstCheckCreatedA);
        const mostRecentB = moment.max(lastUploadB, firstCheckCreatedB);

        return mostRecentB.diff(mostRecentA);
      });

      console.log("This is from queryProperties, after we sort", sortedProperties);
    
    const propertyUUIDs = sortedProperties?.map(property => property?.uuid);


    let nextIndex = 0;
    
    const loadAdditionalProperties = async () => {
      setIsLoadingMore(true);
      
      // Check if request was cancelled before proceeding
      if (abortSignal?.aborted) {
        // console.log(`🚫 LoadAdditionalProperties [${searchId}] aborted before loading batch`);
        setIsLoadingMore(false);
        throw new DOMException('Request was cancelled', 'AbortError');
      }
      
      if (nextIndex === 0) {
          setPropertyList([]);
      }
      const currentBatchUUIDs = propertyUUIDs.slice(nextIndex, nextIndex + pageSize);
      nextIndex += pageSize;
  
      // Only log if loading many batches
      if (propertyUUIDs.length > 100) {
        console.log(`📦 LoadAdditionalProperties [${searchId}] loading batch ${nextIndex/pageSize} of ${Math.ceil(propertyUUIDs.length/pageSize)} (${currentBatchUUIDs.length} properties)`);
      }
      
      // UPDATED: Use getCardDataForFavorites instead of getCardData for consistency
      const morePropertiesBatch = await Property.getCardDataForFavorites(
        currentBatchUUIDs, 
        userId, 
        utcStartDate, 
        utcEndDate,
        user.company?.id,
        abortSignal, // Pass abort signal to API call
        searchId // Pass search ID for logging
      );
      
      // Check if request was cancelled after API call
      if (abortSignal?.aborted) {
        // console.log(`🚫 LoadAdditionalProperties [${searchId}] aborted after API call`);
        setIsLoadingMore(false);
        throw new DOMException('Request was cancelled', 'AbortError');
      }
      
      const moreProperties = morePropertiesBatch.filter(property => property !== null);

      setPropertyList(prevList => {
          const uniqueUuids = [...new Set([...prevList, ...moreProperties].map(item => item.uuid))];
          return uniqueUuids.map(uuid => prevList.find(item => item.uuid === uuid) || moreProperties.find(item => item.uuid === uuid));
      });
  
      if (nextIndex >= propertyUUIDs.length) {
          setHasMoreItems(false);
      }
      setIsLoadingMore(false);
    };

    return loadAdditionalProperties;
  };

  const calculateWeightedCenter = (markers) => {
    let latSum = 0, lngSum = 0, totalWeight = 0;
  
    markers.forEach(marker => {
      const weight = 1;
      latSum += marker.lat * weight;
      lngSum += marker.lng * weight;
      totalWeight += weight;
    });
  
    if (totalWeight === 0) {
      return null; 
    }
  
    return {
      lat: latSum / totalWeight,
      lng: lngSum / totalWeight
    };
  };

  const updateMapCenterAndZoom = (propertyList) => {
    propertyList = propertyList.filter(p => p.lat !== null && p.lng !== null);
    const center = calculateWeightedCenter(propertyList);
    if (center) {
      setMapLat(center.lat);
      setMapLng(center.lng);
      setMapZoom(initialZoomLevel);
    } else {
      setMapLat(defaultLat);
      setMapLng(defaultLng);
      setMapZoom(defaultZoom); 
    }
  }

  // Modified state variables for favorited properties feature
  // viewMode now comes from context via inspectionViewMode
  const [currentUserData, setCurrentUserData] = useState(null);
  const [hasFavorites, setHasFavorites] = useState(false);
  const [userDataFetched, setUserDataFetched] = useState(false); // Track if user data has been loaded
  const [favoritedProperties, setFavoritedProperties] = useState([]);
  
  // Property list state variables
  // selectedPropertyList now comes from context
  const [propertyListProperties, setPropertyListProperties] = useState([]);
  const [loadingPropertyList, setLoadingPropertyList] = useState(false);

  // State for work orders section
  const [showWorkOrdersSection, setShowWorkOrdersSection] = useState(false);

  // Work orders state - shared between InspectionWorkOrdersSection and ChatWidget
  const [workOrders, setWorkOrders] = useState([]);
  const [filteredWorkOrders, setFilteredWorkOrders] = useState([]);
  const [loadingWorkOrders, setLoadingWorkOrders] = useState(false);

  const currentAbortControllerRef = useRef(null);
  const activeSearchRef = useRef({ key: null, controller: null });

  const search = async (abortSignal, searchId) => {
    setIsSearchLoading(true);

    if (!user.selectedProperty) {
      setLoading(true);

      // Check if request was cancelled before proceeding
      if (abortSignal?.aborted) {
        // console.log(`🚫 Search [${searchId}] aborted before starting`);
        throw new DOMException('Request was cancelled', 'AbortError');
      }

      // Handle favorited properties view (use enableViewModeFiltering or isInspectionPage for backward compatibility)
      const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;

      if (shouldEnableFiltering && inspectionViewMode === 'favorited') {
        // Only switch away from favorites if we've fetched user data and confirmed no favorites
        if (!hasFavorites && userDataFetched) {
          console.log('🔄 User has no favorites (confirmed after fetching), switching to inspection view');
          setInspectionViewMode('inspection');
          setLoading(false);
          setIsSearchLoading(false);
          return;
        }

        // Load favorites even if hasFavorites is false (might not be initialized yet)
        await loadFavoritedProperties(abortSignal, searchId);
        setLoading(false);
        setIsSearchLoading(false);
        return;
      }

      // Handle property list view
      if (shouldEnableFiltering && inspectionViewMode === 'propertyList') {
        // Check if a property list is selected
        if (!selectedPropertyList) {
          console.log('🔄 No property list selected, switching to inspection view');
          setInspectionViewMode('inspection');
          setLoading(false);
          setIsSearchLoading(false);
          return;
        }

        await loadPropertyListProperties(abortSignal, searchId);
        setLoading(false);
        setIsSearchLoading(false);
        return;
      }

      // Reset favorited properties and property list properties when not in those modes
      // Only apply this logic for pages with view mode filtering enabled
      if (!shouldEnableFiltering || inspectionViewMode === 'inspection') {
        setFavoritedProperties([]);
        setPropertyListProperties([]);
      }

      // Reset hasMoreItems to true at the start of each search
      setHasMoreItems(true);

      // Check abort signal before expensive operations
      if (abortSignal?.aborted) {
        // console.log(`🚫 Search [${searchId}] aborted during setup`);
        throw new DOMException('Request was cancelled', 'AbortError');
      }

      // Existing logic for inspection and analytics pages
      let loadMoreProperties;

      if (isInspectionPage) {
        loadMoreProperties = await queryProperties(
          user.id,
          propertyNameFilter,
          property => {
            const lastUpload = property.last_upload_at !== null ? moment(property.last_upload_at).unix() : 0;
            const firstCheck = property.checks && property.checks.edges.length > 0
              ? moment(property.checks.edges[0].node.created_at).unix()
              : 0;
            return Math.max(lastUpload, firstCheck);
          },
          50, // pageSize - increased from 20 to 50
          abortSignal, // Pass abort signal
          searchId // Pass search ID for logging
        );
      } else if (isAnalyticsPage) {
        loadMoreProperties = await queryProperties(
          user.id,
          propertyNameFilter,
          property => property.last_upload_at !== null ? moment(property.last_upload_at).unix() : -1,
          50, // pageSize - increased from 20 to 50
          abortSignal, // Pass abort signal
          searchId // Pass search ID for logging
        );
      } else {
        loadMoreProperties = await queryPropertiesGeneric(abortSignal, searchId, 50);
      }

      // Check abort signal before loading initial batch
      if (abortSignal?.aborted) {
        // console.log(`🚫 Search [${searchId}] aborted before loading initial batch`);
        throw new DOMException('Request was cancelled', 'AbortError');
      }

      // Load initial batch of properties
      await loadMoreProperties();

      // Store the function for loading more properties
      setLoadMore(() => loadMoreProperties);

      setLoading(false);
    }
    setIsSearchLoading(false);
  };

  // Modified function to fetch current user data with fresh favorite_properties
  const fetchCurrentUserData = async (abortSignal, searchId) => {
    try {
      // Check if request was cancelled before making API call
      if (abortSignal?.aborted) {
        // console.log(`🚫 FetchCurrentUserData [${searchId}] aborted before API call`);
        throw new DOMException('Request was cancelled', 'AbortError');
      }
      
      // console.log(`📡 FetchCurrentUserData [${searchId}] calling User.findByUUID`);
      const freshUserData = await User.findByUUID(user.uuid, abortSignal, searchId);
      setCurrentUserData(freshUserData);
      
      // Check if user has favorites and parse JSON
      let favoriteUuids = [];
      if (freshUserData?.favorite_properties) {
        try {
          const parsedFavorites = JSON.parse(freshUserData.favorite_properties);
          favoriteUuids = Array.isArray(parsedFavorites) ? parsedFavorites : [];
        } catch (parseError) {
          console.warn('Error parsing favorite_properties:', parseError);
          favoriteUuids = [];
        }
      }
      
      const hasUserFavorites = favoriteUuids.length > 0;
      setHasFavorites(hasUserFavorites);
      setUserDataFetched(true); // Mark that we've fetched user data
      
      // Set initial view mode based on whether user has favorites (only if not already set)
      const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;
      if (shouldEnableFiltering && inspectionViewMode === null) {
        const newViewMode = hasUserFavorites ? 'favorited' : 'inspection';
        console.log(`🎯 Setting initial viewMode to '${newViewMode}' (user has ${hasUserFavorites ? 'favorites' : 'no favorites'})`);
        setInspectionViewMode(newViewMode);
      }
      
      return { freshUserData, favoriteUuids };
    } catch (error) {
      console.error('Error fetching user data:', error);
      setHasFavorites(false);
      setUserDataFetched(true); // Mark as fetched even on error
      // Set default viewMode if there was an error
      const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;
      if (shouldEnableFiltering && inspectionViewMode === null) {
        setInspectionViewMode('inspection');
      }
      return { freshUserData: null, favoriteUuids: [] };
    }
  };

  // Function to fetch available property lists for the company
  const fetchPropertyLists = async (abortSignal, searchId) => {
    try {
      // Check if request was cancelled before making API call
      if (abortSignal?.aborted) {
        throw new DOMException('Request was cancelled', 'AbortError');
      }
      
      // Only fetch if user has company
      if (!user?.company?.id) {
        return [];
      }

      console.log(`📡 FetchPropertyLists [${searchId}] calling PropertyList.getPropertyListsByCompany`);
      const lists = await PropertyList.getPropertyListsByCompany(user.company.id);

      return lists || [];
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error fetching property lists:', error);
      }
      return [];
    }
  };

  // Modified function to load favorited properties with concurrent chunked loading and progress tracking
  const loadFavoritedProperties = async (abortSignal, searchId) => {
    try {
      // Check if request was cancelled before starting
      if (abortSignal?.aborted) {
        // console.log(`🚫 LoadFavoritedProperties [${searchId}] aborted before starting`);
        throw new DOMException('Request was cancelled', 'AbortError');
      }
      
      setLoadingFavorites(true);
      setFavoritedProperties([]); // Clear existing to show progressive loading
      
      // If currentUserData is not available, fetch it first
      let userData = currentUserData;
      if (!userData && user?.uuid) {
        console.log('📡 Fetching user data in loadFavoritedProperties');
        try {
          userData = await User.findByUUID(user.uuid, abortSignal, searchId);
          setCurrentUserData(userData);
          const hasFavs = userData?.favorite_properties ? 
            JSON.parse(userData.favorite_properties).length > 0 : false;
          setHasFavorites(hasFavs);
          setUserDataFetched(true);
        } catch (error) {
          console.error('Error fetching user data in loadFavoritedProperties:', error);
          setLoadingFavorites(false);
          return;
        }
      }
      
      // Use the fetched or existing user data
      let favoriteUuids = [];
      if (userData?.favorite_properties) {
        try {
          const parsedFavorites = JSON.parse(userData.favorite_properties);
          favoriteUuids = Array.isArray(parsedFavorites) ? parsedFavorites : [];
        } catch (parseError) {
          console.warn('Error parsing favorite_properties:', parseError);
          favoriteUuids = [];
        }
      }
      
      if (favoriteUuids.length === 0) {
        console.log('📭 User has no favorited properties');
        setFavoritedProperties([]);
        setHasMoreItems(false);
        setLoadingFavorites(false);
        return;
      }

      // Convert local dates to UTC range that covers the entire local day
      const utcStartDate = moment(startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
      const utcEndDate = moment(endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');


      // Split favoriteUuids into chunks of 50 to avoid GraphQL query complexity issues
      const chunkSize = 50;
      const chunks = [];
      for (let i = 0; i < favoriteUuids.length; i += chunkSize) {
        chunks.push(favoriteUuids.slice(i, i + chunkSize));
      }

      // Initialize progress tracking
      setFavoritesLoadingProgress({
        currentChunk: 0,
        totalChunks: chunks.length,
        loadedCount: 0,
        totalCount: favoriteUuids.length
      });


      // Use p-limit to load chunks concurrently (2 at a time for optimal performance/server load balance)
      const limit = pLimit(2);
      const allFavoritedProperties = [];
      let completedChunks = 0;

      // Create promises for all chunks with progress tracking
      const chunkPromises = chunks.map((chunk, index) => 
        limit(async () => {
          // Check if request was cancelled before processing chunk
          if (abortSignal?.aborted) {
            // console.log(`🚫 LoadFavoritedProperties [${searchId}] chunk ${index + 1} aborted`);
            throw new DOMException('Request was cancelled', 'AbortError');
          }
          
          // console.log(`📡 LoadFavoritedProperties [${searchId}] loading chunk ${index + 1}/${chunks.length} with ${chunk.length} properties`);
          
          // UPDATED: Use the new optimized method for favorites without pointInfos
          const chunkData = await Property.getCardDataForFavorites(
            chunk,
            user.id,
            utcStartDate,  // Use UTC dates
            utcEndDate,    // Use UTC dates
            user.company?.id,
            abortSignal, // Pass abort signal
            searchId // Pass search ID for logging
          );

          
          const validChunkProperties = chunkData.filter(property => property !== null);
          completedChunks++;
          
          // Update progress
          setFavoritesLoadingProgress(prev => ({
            ...prev,
            currentChunk: completedChunks,
            loadedCount: prev.loadedCount + validChunkProperties.length
          }));
          
          console.log(`Chunk ${index + 1} loaded: ${validChunkProperties.length} valid properties (${completedChunks}/${chunks.length} chunks complete)`);
          
          return validChunkProperties;
        })
      );

      // Wait for all chunks to complete and combine results
      const chunkResults = await Promise.all(chunkPromises);
      chunkResults.forEach(chunkProperties => {
        allFavoritedProperties.push(...chunkProperties);
      });
      
      
      // Apply the same sorting logic as used in queryProperties
      const sortedFavorites = allFavoritedProperties.sort((a, b) => {
        const lastUploadA = a.last_upload_at ? moment(a.last_upload_at) : moment(0);
        const lastUploadB = b.last_upload_at ? moment(b.last_upload_at) : moment(0);

        const firstCheckCreatedA = a.checks?.edges[0]?.node?.created_at ? moment(a.checks.edges[0].node.created_at) : moment(0);
        const firstCheckCreatedB = b.checks?.edges[0]?.node?.created_at ? moment(b.checks.edges[0].node.created_at) : moment(0);

        const mostRecentA = moment.max(lastUploadA, firstCheckCreatedA);
        const mostRecentB = moment.max(lastUploadB, firstCheckCreatedB);

        return mostRecentB.diff(mostRecentA);
      });
      
      setFavoritedProperties(sortedFavorites);
      setHasMoreItems(false);
      
    } catch (error) {
      console.error('Error loading favorited properties:', error);
      setFavoritedProperties([]);
      setHasMoreItems(false);
    } finally {
      setLoadingFavorites(false);
      // Reset progress
      setFavoritesLoadingProgress({
        currentChunk: 0,
        totalChunks: 0,
        loadedCount: 0,
        totalCount: 0
      });
    }
  };

  // Function to load properties from selected property list
  const loadPropertyListProperties = async (abortSignal, searchId) => {
    try {
      if (abortSignal?.aborted) {
        throw new DOMException('Request was cancelled', 'AbortError');
      }
      
      setLoadingPropertyList(true);
      setPropertyListProperties([]); // Clear existing to show progressive loading
      
      if (!selectedPropertyList) {
        console.log('📭 No property list selected');
        setPropertyListProperties([]);
        setHasMoreItems(false);
        setLoadingPropertyList(false);
        return;
      }
      
      // Get property UUIDs from the selected list (properties_list is a JSON string)
      let propertyUuids = [];
      if (selectedPropertyList.properties_list) {
        try {
          propertyUuids = [...new Set(JSON.parse(selectedPropertyList.properties_list))];
        } catch (e) {
          console.error('Error parsing properties_list:', e);
          propertyUuids = [];
        }
      }
      if (propertyUuids.length === 0) {
        console.log('📭 Property list has no properties');
        setPropertyListProperties([]);
        setHasMoreItems(false);
        setLoadingPropertyList(false);
        return;
      }
      
      console.log(`📋 Loading ${propertyUuids.length} properties from list: ${selectedPropertyList.name}`);
      
      // Convert local dates to UTC range that covers the entire local day
      const utcStartDate = moment(startDate).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
      const utcEndDate = moment(endDate).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss');
      
      // Use the same loading method as favorites for consistency
      const listPropertyData = await Property.getCardDataForFavorites(
        propertyUuids,
        user.id,
        utcStartDate,  // Use UTC dates
        utcEndDate,    // Use UTC dates
        user.company?.id,
        abortSignal, // Pass abort signal
        searchId // Pass search ID for logging
      );
      
      const validListProperties = listPropertyData.filter(property => property !== null);
      
      // Apply the same sorting logic as used in queryProperties
      const sortedListProperties = validListProperties.sort((a, b) => {
        const lastUploadA = a.last_upload_at ? moment(a.last_upload_at) : moment(0);
        const lastUploadB = b.last_upload_at ? moment(b.last_upload_at) : moment(0);

        const firstCheckCreatedA = a.checks?.edges[0]?.node?.created_at ? moment(a.checks.edges[0].node.created_at) : moment(0);
        const firstCheckCreatedB = b.checks?.edges[0]?.node?.created_at ? moment(b.checks.edges[0].node.created_at) : moment(0);

        const mostRecentA = moment.max(lastUploadA, firstCheckCreatedA);
        const mostRecentB = moment.max(lastUploadB, firstCheckCreatedB);

        return mostRecentB.diff(mostRecentA);
      });
      
      setPropertyListProperties(sortedListProperties);
      setHasMoreItems(false);
      
    } catch (error) {
      console.error('Error loading property list properties:', error);
      setPropertyListProperties([]);
      setHasMoreItems(false);
    } finally {
      setLoadingPropertyList(false);
    }
  };

  // Work orders fetching logic - only for Meijer (company_id 1121)
  const CHUNK_SIZE = 100;
  const MAX_CONCURRENCY = 6;
  const workOrdersLimit = pLimit(MAX_CONCURRENCY);

  // Fetch chunk of work orders by IDs
  const fetchWorkOrdersChunk = async (ids) => {
    const searchList = [{ field: 'work_order_id', value: ids, comparison: 'IN' }];
    const { data } = await WorkOrders.filterBy(
      searchList,
      'dt_created',
      'desc',
      10000,
      undefined,
      undefined,
      undefined,
      true
    );
    return data;
  };

  // Fetch all work orders in date range
  const fetchWorkOrdersByDateRange = useCallback(async () => {
    if (user?.company?.id !== "1121") {
      // Only fetch work orders for Meijer
      setWorkOrders([]);
      setFilteredWorkOrders([]);
      return;
    }

    console.log('[PropertyActivityGrid] Fetching work orders by date range');
    setLoadingWorkOrders(true);

    try {
      // Get work order IDs by date range
      const workOrderIds = await WorkOrders.getWorkOrderIdsByDateRange(
        moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
        moment(endDate).add(1, 'day').format('YYYY-MM-DD HH:mm:ss')
      );

      console.log('[PropertyActivityGrid] Work Order IDs by Date Range:', workOrderIds.length);

      // Break work order IDs into chunks
      const chunks = [];
      for (let i = 0; i < workOrderIds.length; i += CHUNK_SIZE) {
        chunks.push(workOrderIds.slice(i, i + CHUNK_SIZE));
      }

      // Fetch work orders for each chunk in parallel
      let allWorkOrders = [];
      await Promise.all(
        chunks.map((chunk) =>
          workOrdersLimit(() => fetchWorkOrdersChunk(chunk).then((res) => allWorkOrders.push(...res)))
        )
      );

      console.log('[PropertyActivityGrid] Total work orders fetched:', allWorkOrders.length);
      setWorkOrders(allWorkOrders);
    } catch (err) {
      console.error('[PropertyActivityGrid] Error fetching work orders:', err);
      setWorkOrders([]);
    } finally {
      setLoadingWorkOrders(false);
    }
  }, [startDate, endDate, user?.company?.id]);

  // Apply filtering to work orders based on view mode
  const applyWorkOrdersFiltering = useCallback(() => {
    if (inspectionViewMode === 'favorited') {
      // Filter by favorited properties
      let favoriteUuids = [];
      if (currentUserData?.favorite_properties) {
        try {
          const parsedFavorites = JSON.parse(currentUserData.favorite_properties);
          favoriteUuids = Array.isArray(parsedFavorites) ? parsedFavorites : [];
        } catch (parseError) {
          console.warn('[PropertyActivityGrid] Error parsing favorite_properties:', parseError);
          favoriteUuids = [];
        }
      }

      if (favoriteUuids.length === 0) {
        setFilteredWorkOrders([]);
        return;
      }

      const favoritedWorkOrders = workOrders.filter(
        (workOrder) => workOrder.property_uuid && favoriteUuids.includes(workOrder.property_uuid)
      );
      setFilteredWorkOrders(favoritedWorkOrders);
    } else if (inspectionViewMode === 'propertyList') {
      // Filter by selected property list
      if (!selectedPropertyList) {
        setFilteredWorkOrders([]);
        return;
      }

      let propertyUuids = [];
      if (selectedPropertyList.properties_list) {
        try {
          propertyUuids = [...new Set(JSON.parse(selectedPropertyList.properties_list))];
        } catch (e) {
          console.error('[PropertyActivityGrid] Error parsing properties_list:', e);
          propertyUuids = [];
        }
      }

      if (propertyUuids.length === 0) {
        setFilteredWorkOrders([]);
        return;
      }

      const propertyListWorkOrders = workOrders.filter(
        (workOrder) => workOrder.property_uuid && propertyUuids.includes(workOrder.property_uuid)
      );
      setFilteredWorkOrders(propertyListWorkOrders);
    } else {
      // Show all work orders (inspection view)
      setFilteredWorkOrders(workOrders);
    }
  }, [inspectionViewMode, workOrders, currentUserData, selectedPropertyList]);

  // Fetch work orders when date range changes (only for Meijer)
  useEffect(() => {
    if (isInspectionPage && user?.company?.id === "1121" && startDate && endDate) {
      fetchWorkOrdersByDateRange();
    }
  }, [startDate, endDate, isInspectionPage, fetchWorkOrdersByDateRange]);

  // Apply filtering when view mode or work orders change
  useEffect(() => {
    if (isInspectionPage && user?.company?.id === "1121") {
      applyWorkOrdersFiltering();
    }
  }, [isInspectionPage, user?.company?.id, applyWorkOrdersFiltering]);

  // Modified useEffect to handle both pages with and without view mode filtering
  useEffect(() => {
    const abortController = new AbortController();
    const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;

    if (shouldEnableFiltering) {
      // For pages with view mode filtering, fetch user data to determine if they have favorites
      fetchCurrentUserData(abortController.signal, 'init_user_data');
    } else {
      // For pages without filtering, set viewMode to allow search to run
      if (inspectionViewMode === null) {
        setInspectionViewMode('generic'); // Use 'generic' for non-filtering pages
      }
    }

    return () => {
      abortController.abort();
    };
  }, [user?.uuid, enableViewModeFiltering, isInspectionPage]);

  // Separate useEffect for fetching property lists when view mode filtering is enabled
  useEffect(() => {
    const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;
    if (!shouldEnableFiltering || !user?.company?.id) return;
    
    const abortController = new AbortController();
    fetchPropertyLists(abortController.signal, 'init_property_lists');
    
    return () => {
      abortController.abort();
    };
  }, [user?.company?.id, enableViewModeFiltering, isInspectionPage]);

  // Enhanced useEffect with AbortController and deduplication
  // Dedup prevents the race condition where changing dates + triggering search simultaneously
  // causes the debounced date key change (1s later) to abort the already-running search.
  useEffect(() => {
    // Guard clause: Don't run search if viewMode is not set yet
    if (inspectionViewMode === null) {
      console.log('⏳ Waiting for viewMode to be initialized...');
      return;
    }

    // Compute key from all effective search parameters
    const searchKey = `${user?.company?.id}_${startDate}_${endDate}_${inspectionViewMode}_${propertyNameFilter}_${propertySearchTrigger}_${selectedPropertyList?.id}`;

    // DEDUP: If same search is already running, skip (prevents debounce race)
    if (activeSearchRef.current.key === searchKey) {
      return;
    }

    // Different search — abort previous, start new
    activeSearchRef.current.controller?.abort();

    const abortController = new AbortController();
    activeSearchRef.current = { key: searchKey, controller: abortController };
    currentAbortControllerRef.current = abortController;

    const searchId = `search_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    console.log(`🔍 Starting search [${searchId}] - viewMode: ${inspectionViewMode}`);

    const executeSearch = async () => {
      try {
        await search(abortController.signal, searchId);
      } catch (error) {
        if (error.name === 'AbortError') {
          console.log(`🚫 Search cancelled [${searchId}] - user changed filters`);
        } else {
          console.error(`❌ Search failed [${searchId}]:`, error);
        }
      }
    };

    executeSearch();

    // Don't abort in cleanup — dedup logic above handles it.
    // This prevents the debounced date key re-trigger from aborting an active search.
    return () => {};
  }, [user && user.company && user.company.id, debouncedDateKey, inspectionViewMode, propertySearchTrigger, selectedPropertyList]);

  // Abort active search on unmount
  useEffect(() => {
    return () => { activeSearchRef.current.controller?.abort(); };
  }, []);

  // useEffect(() => {
  //   console.log("hasMoreItems var", hasMoreItems);
  // }, [hasMoreItems]);


  const startMoment = moment(startDate).startOf('day');
  const endMoment = moment(endDate).endOf('day');

  useEffect(() => {
    setLoadingMsi(true);
    
    // Check if the current search was aborted
    if (currentAbortControllerRef.current?.signal.aborted) {
      setLoadingMsi(false);
      return;
    }
    
    // Skip filtering logic for favorited properties (only for pages with view mode filtering)
    const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;
    if (shouldEnableFiltering && inspectionViewMode === 'favorited') {
      setDataToRender(favoritedProperties);
      setLoadingMsi(false);
      return;
    }

    // Skip filtering logic for property list properties (only for pages with view mode filtering)
    if (shouldEnableFiltering && inspectionViewMode === 'propertyList') {
      setDataToRender(propertyListProperties);
      setLoadingMsi(false);
      return;
    }

    // Convert local dates to UTC range for consistent client-side filtering
    // This should match the server-side filtering logic
    const utcStartMoment = moment(startDate).startOf('day').utc();
    const utcEndMoment = moment(endDate).endOf('day').utc();


    // Regular filtering logic for inspection/analytics pages
    let filteredPropertyActivityHistory = propertyActivityHistory
      .filter(row => {
        // Retrieve the two dates 
        const recordedAtDate = row?.vals?.edges?.[0]?.node?.recorded_at || '';
        const createdAtDate = row?.checks?.edges?.[0]?.node?.created_at || '';

        // Parse the UTC timestamps from the server
        const recordedAtMoment = recordedAtDate ? moment.utc(recordedAtDate) : null;
        const createdAtMoment = createdAtDate ? moment.utc(createdAtDate) : null;
        const momentsArray = [recordedAtMoment, createdAtMoment].filter(m => m && m.isValid());
        
        if (momentsArray.length === 0) return false;

        // Determine the most recent of the two dates
        const mostRecentMoment = momentsArray.length > 0 ? moment.max(...momentsArray) : null;

        // Check if the most recent date is between utcStartMoment and utcEndMoment
        const isInRange = mostRecentMoment.isBetween(utcStartMoment, utcEndMoment, null, '[]');
        
        
        return isInRange;
      })
      .sort((a, b) => {
        const momentsA = [
          a?.vals?.edges[0]?.node?.recorded_at ? moment.utc(a.vals.edges[0].node.recorded_at) : null,
          a?.checks?.edges[0]?.node?.created_at ? moment.utc(a.checks.edges[0].node.created_at) : null
        ].filter(m => m && m.isValid());

        const momentsB = [
          b?.vals?.edges[0]?.node?.recorded_at ? moment.utc(b.vals.edges[0].node.recorded_at) : null,
          b?.checks?.edges[0]?.node?.created_at ? moment.utc(b.checks.edges[0].node.created_at) : null
        ].filter(m => m && m.isValid());

        const mostRecentDateA = momentsA.length > 0 ? moment.max(...momentsA) : null;
        const mostRecentDateB = momentsB.length > 0 ? moment.max(...momentsB) : null;

        if (!mostRecentDateA && !mostRecentDateB) return 0;
        if (!mostRecentDateA) return 1;
        if (!mostRecentDateB) return -1;

        if (mostRecentDateA.isBefore(mostRecentDateB)) {
          return 1;
        }

        if (mostRecentDateA.isAfter(mostRecentDateB)) {
          return -1;
        }

        return 0;
      });
      
    console.log("This is the Filtered propertyActivityHistory", filteredPropertyActivityHistory);

    let dataToRenderVar = (isInspectionPage || isAnalyticsPage) ? filteredPropertyActivityHistory : propertyActivityHistory;
    setDataToRender(dataToRenderVar);
    
    if(isInspectionPage || isAnalyticsPage) {
      // Initialize a Set outside the reduce method to keep track of all unique unit_dec values
      let uniqueDeviceUnitDecs = new Set();
      const totalCounts = dataToRenderVar.reduce((acc, curr) => {
        // Count unique inspections based on point_num
        const equipmentCount = curr?.vals
          ? Object.keys(_.groupBy(curr?.vals?.edges, edge => edge?.node && edge?.node?.point_num)).length
          : 0;

        // Add each unit_dec to the Set for unique MSI devices
        curr?.vals?.edges.forEach(edge => {
          if (edge?.node && edge?.node?.wav && edge?.node?.wav?.unit_dec) {
            uniqueDeviceUnitDecs.add(edge?.node?.wav?.unit_dec);
          }
        });

        // Update the accumulator for inspections
        acc.inspections += equipmentCount;

        return acc;
      }, { inspections: 0 }); // Initial accumulator now includes counter for inspections only

      // Set the total counts using respective state update functions
      setTotalMsiInspections(totalCounts.inspections);
      // The total unique devices is the size of uniqueDeviceUnitDecs
      setTotalMsiDevices(uniqueDeviceUnitDecs.size);

      const totalUniqueUsers = dataToRenderVar.reduce((acc, curr) => {
        // Use the same UTC date range for user filtering
        const utcStartMoment = moment(startDate).startOf('day').utc();
        const utcEndMoment = moment(endDate).endOf('day').utc();
        
        // 1st Criteria: Collect unique user IDs from vals.edges.node.user.id
        const userIDsFromVals = curr?.vals?.edges
          .map(edge => edge?.node?.wav?.user?.id.toString())
          .filter(id => id !== undefined);
        // 3rd Criteria: Collect unique user IDs from checks.edges.node.user.id
        const userIDsFromChecks = curr?.checks?.edges
          .map(edge => edge?.node?.user?.id.toString())
          .filter(id => id !== undefined);

        const combinedUserIDs = [...userIDsFromVals, ...userIDsFromChecks];

        // Add last_evaluation_user_id if it exists and is within the date range
        if (curr.last_evaluation_user_id && curr.last_evaluation_at) {
          const evalMoment = moment.utc(curr.last_evaluation_at);
          if (evalMoment.isBetween(utcStartMoment, utcEndMoment, null, '[]')) {
            combinedUserIDs.push(curr.last_evaluation_user_id.toString());
          }
        }

        // Add unique IDs from this iteration to the accumulator Set
        acc = new Set([...acc, ...combinedUserIDs]);

        return acc;
      }, new Set()).size; // Use a Set to automatically handle uniqueness and .size for the count

      // Set the total unique user IDs count as totalUniqueUsers
      setTotalUniqueUsers(totalUniqueUsers);
    }
    
    setLoadingMsi(false);
  }, [propertyActivityHistory, inspectionViewMode, favoritedProperties, propertyListProperties]);


  // Data list transitions logging
  useEffect(() => {
    console.log('[Mike][PropertyActivityGrid]', 'dataToRender changed', {
      dataToRender: dataToRender.length,
      propertyActivityHistory: propertyActivityHistory.length,
      favoritedProperties: favoritedProperties.length,
      propertyListProperties: propertyListProperties.length,
      viewMode: inspectionViewMode
    });
  }, [dataToRender.length, propertyActivityHistory.length, favoritedProperties.length, propertyListProperties.length, inspectionViewMode]);

  useEffect(() => {
    if (propertyActivityHistory && propertyActivityHistory.length > 0) {
      updateMapCenterAndZoom(propertyActivityHistory);
    }
  }, [propertyActivityHistory]);

  const GoogleMap = (props) => {
    const [propertyMarkers, setPropertyMarkers] = useState([]);

    useEffect(() => {
      setPropertyMarkers(props.propertyActivityHistory)
    }, [props.propertyActivityHistory])

    return (
      <div style={{ height: '300px', width: '100%' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: GOOGLEMAP_API_KEY }}
          center={{
            lat: props.mapLat,
            lng: props.mapLng
          }}
          defaultZoom={mapZoom}
          hoverDistance={20}
        >
          {propertyMarkers && propertyMarkers.filter(pa => pa.lat !== null && pa.lng !== null).map(pa => {
            return (
              <abbr
                key={pa.uuid}
                lat={pa.lat}
                lng={pa.lng}
                text={pa.name}
                title={pa.name}
              >
                <FaMapMarkerAlt
                  style={{ fontSize: '20px', position: 'absolute', transform: 'translate(-50%, -50%)', color: pa.lat === props.mapLat && pa.lng === props.mapLng ? 'blue' : null }}
                  onClick={() => {
                    setSelectedPropertyResult(pa)
                  }}
                />
              </abbr>
            )
          })}
        </GoogleMapReact>
      </div>
    )
  }


  // Modified loading condition - only show spinner for pages with filtering during viewMode determination
  const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;
  if (shouldEnableFiltering && inspectionViewMode === null) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
        <ImSpinner3 className="icon-spin" style={{ fontSize: 40 }} />
      </div>
    );
  }

  // Add this new callback function near other functions
  const handleFavoritesUpdate = async () => {
    const abortController = new AbortController();
    try {
      // Refresh the current user data to get updated favorites
      await fetchCurrentUserData(abortController.signal, 'toggle_favorite');
      
      // If we're in favorited view, also refresh the favorited properties list
      const shouldEnableFiltering = enableViewModeFiltering || isInspectionPage;
      if (shouldEnableFiltering && inspectionViewMode === 'favorited') {
        await loadFavoritedProperties(abortController.signal, 'refresh_favorites');
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error updating favorites:', error);
      }
    }
  };

  // Smart transition detection - detects when switching to inspection mode but don't have data yet
  const isTransitioningToInspection = inspectionViewMode === 'inspection' && 
                                      dataToRender.length === 0 && 
                                      propertyActivityHistory.length === 0 &&
                                      (isSearchLoading || loading);

  return (
    <>
      {user && !user.selectedProperty && <div className="d-flex flex-column" style={{ position: 'sticky', top: '-2.5em', zIndex: 100, backgroundColor: 'white' }}>
        <div className="d-flex flex-row justify-content-between">
          <h3>{title}</h3>
          <div className="d-flex flex-row justify-content-end">

            {/* Existing Map Toggle */}
            {!hideMap &&
              <div className="mt-1">
                <button 
                  onClick={() => setShowMap(!showMap)} 
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#0056b3',
                    color: '#fff',
                    border: '1px solid #0056b3',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    marginTop: '-10px',    
                    marginBottom: '10px',
                    marginRight: '20px',  
                    fontSize: '14px',
                    fontWeight: '500',
                    transition: 'background-color 0.3s, color 0.3s, border-color 0.3s',
                    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                    outline: 'none'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#004494';
                    e.target.style.borderColor = '#004494';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#0056b3';
                    e.target.style.borderColor = '#0056b3';
                  }}
                >
                  {showMap ? 'Hide Map' : 'Show Map'}
                </button>
              </div>
            }

            {/* Search Input - Only show in All Inspections view or generic (non-filtering) pages */}
            {(!(enableViewModeFiltering || isInspectionPage) || inspectionViewMode === 'inspection' || inspectionViewMode === 'generic') && (
              <div className="">
                <span className="font-weight-bold align-self-center">Search by Name:</span>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="search-tooltip">Press Enter to Search</Tooltip>}
                >
                  <input 
                    type="text" 
                    placeholder="Name" 
                    onKeyPress={handleKeyPress} 
                    onChange={(e) => {
                      setPropertyNameFilter(e.target.value);
                    }}
                  />
                </OverlayTrigger>
              </div>
            )}
            
            {!isInspectionPage && <div className="ml-2">
              <span className="font-weight-bold align-self-center">Status:&nbsp;</span>
              <select
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                style={{ height: '2em' }}
              >
                <option value="all">All</option>
                <option value="active">Active</option>
                <option value="pending">Pending</option>
                <option value="inactive">Inactive</option>
                <option value="none">Not set</option>
              </select>
            </div>}

            {additionalButtons && additionalButtons.map(button => {
              return button;
            })}
          </div>
        </div>

        {/* Favorited Properties Information */}
        {(enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'favorited' && !loadingFavorites && (
          <div className="d-flex justify-content-center mb-2">
            <div style={{
              padding: '8px 16px',
              backgroundColor: '#e7f3ff',
              border: '1px solid #b3d9ff',
              borderRadius: '4px',
              color: '#004085',
              fontSize: '14px'
            }}>
              {dataToRender.length > 0 
                ? `Showing ${dataToRender.length} favorited properties for selected date range`
                : 'No favorited properties found for the selected date range. You can favorite properties by clicking the star icon on any property card.'
              }
            </div>
          </div>
        )}

        {/* Property Group Information */}
        {(enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'propertyList' && !loadingPropertyList && selectedPropertyList && (
          <div className="d-flex justify-content-center mb-2">
            <div style={{
              padding: '8px 16px',
              backgroundColor: '#f0f9f1',
              border: '1px solid #c8e6c9',
              borderRadius: '4px',
              color: '#2e7d32',
              fontSize: '14px'
            }}>
              {selectedPropertyList && (dataToRender.length > 0 
                ? `Showing ${dataToRender.length} properties from "${selectedPropertyList.name}" for selected date range`
                : `No properties from "${selectedPropertyList.name}" found for the selected date range.`
              )}
            </div>
          </div>
        )}

        {/* Loading Progress Indicator for Favorited Properties */}
        {(enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'favorited' && loadingFavorites && (
          <div className="d-flex flex-column justify-content-center align-items-center mb-3">
            <div style={{
              padding: '16px 24px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              color: '#495057',
              fontSize: '14px',
              minWidth: '300px',
              textAlign: 'center'
            }}>
              <div style={{ marginBottom: '12px' }}>
                <ImSpinner3 className="icon-spin" style={{ fontSize: 20, marginRight: '8px' }} />
                Loading Favorited Properties...
              </div>
              
              {favoritesLoadingProgress.totalChunks > 0 && (
                <>
                  <div style={{ marginBottom: '8px', fontSize: '13px', color: '#6c757d' }}>
                    Chunk {favoritesLoadingProgress.currentChunk} of {favoritesLoadingProgress.totalChunks} 
                    ({favoritesLoadingProgress.loadedCount} of {favoritesLoadingProgress.totalCount} properties loaded)
                  </div>
                  
                  <div style={{ 
                    width: '100%', 
                    height: '8px', 
                    backgroundColor: '#e9ecef', 
                    borderRadius: '4px',
                    overflow: 'hidden'
                  }}>
                    <div style={{
                      width: `${(favoritesLoadingProgress.currentChunk / favoritesLoadingProgress.totalChunks) * 100}%`,
                      height: '100%',
                      backgroundColor: '#007bff',
                      transition: 'width 0.3s ease',
                      borderRadius: '4px'
                    }} />
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        {/* Loading Indicator for Property Group */}
        {(enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'propertyList' && loadingPropertyList && (
          <div className="d-flex justify-content-center mb-3">
            <div style={{
              padding: '12px 20px',
              backgroundColor: '#f8f9fa',
              border: '1px solid #dee2e6',
              borderRadius: '4px',
              color: '#495057',
              fontSize: '14px'
            }}>
              <ImSpinner3 className="icon-spin" style={{ fontSize: 16, marginRight: '8px' }} />
              Loading Property Group Properties...
            </div>
          </div>
        )}

        {/* Existing Map */}
        {!hideMap && user && !user.selectedProperty && !hideMap &&
          <div className="mt-1">
            {showMap && <GoogleMap mapLat={mapLat} mapLng={mapLng} propertyActivityHistory={dataToRender} />}
          </div>
        }

        {/* MAIN CONTENT - Only show property grid, remove all panel logic */}
        <div className="d-flex flex-column align-items-center">
          {/* Work Orders Section - Only for Meijer (company_id 1121) and Inspection Page */}
          {isInspectionPage && user?.company?.id === "1121" && (
            <div style={{ width: '100%', marginBottom: '20px' }}>
              <InspectionWorkOrdersSection
                viewMode={inspectionViewMode}
                startDate={startDate}
                endDate={endDate}
                user={user}
                currentUserData={currentUserData}
                selectedPropertyList={selectedPropertyList}
                isExpanded={showWorkOrdersSection}
                setIsExpanded={setShowWorkOrdersSection}
                workOrders={workOrders}
                filteredWorkOrders={filteredWorkOrders}
                loading={loadingWorkOrders}
              />
            </div>
          )}

          <div className="d-flex flex-row" style={{ overflowY: "hidden", overflowX: (loading || propertyActivityHistory.length === 0) ? "hidden" : "scroll" }}>
            {user && !user.selectedProperty && (loading
              ? <ImSpinner3 className="icon-spin" style={{ fontSize: 25, marginTop: 10 }} />
              : <div>
                <div className={`d-flex flex-row flex-wrap justify-content-start`}>
                  {dataToRender.filter(matchesStatusFilter).length === 0 && !isSearchLoading && !loading && !((enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'favorited' && loadingFavorites) && (
                    <div>
                      {isTransitioningToInspection ? (
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                          <ImSpinner3 className="icon-spin" style={{ fontSize: 40 }} />
                        </div>
                      ) : (
                        ((enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'favorited') ? 
                          <div style={{ 
                            textAlign: 'center', 
                            padding: '40px 20px',
                            color: '#6c757d',
                            fontSize: '16px'
                          }}>
                            <div style={{ marginBottom: '10px' }}>
                              🌟 You haven't favorited any properties yet!
                            </div>
                            <div style={{ fontSize: '14px' }}>
                              Click the star icon on any property card to add it to your favorites.
                            </div>
                          </div>
                          : noResultsMessage
                      )}
                    </div>
                  )}
                  {dataToRender.filter(matchesStatusFilter).map((row, index) => (
                    <PropertyCard
                      index={index}
                      key={index}
                      row={row}
                      hideMapLocation={hideMapLocation}
                      inspectionInfo={isInspectionPage}
                      hideReportInfo={hideReportInfo}
                      setSelectedPropertyResult={setSelectedPropertyResult}
                      mapLat={mapLat}
                      mapLng={mapLng}
                      hideStructureInfo={hideStructureInfo}
                      hideInspectionInfo={hideInspectionInfo}
                      hideAnalysisColors={hideAnalysisColors}
                      sortByReports={sortByReports}
                      setMapCoordinates={(lat, lng) => {
                        setMapLat(lat)
                        setMapLng(lng)
                        setMapZoom(12)
                      }}
                      onFavoritesUpdate={handleFavoritesUpdate}
                      isInFavoritedView={(enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'favorited'}
                      currentUserData={currentUserData}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
          
          {/* Load More Button */}
          {(dataToRender.length !== 0) && !loading && !((enableViewModeFiltering || isInspectionPage) && inspectionViewMode === 'favorited') ? (
            hasMoreItems ? (
              <button ref={loadMoreRef} onClick={loadMore} style={{
                  padding: '10px 20px',
                  margin: '10px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
              }}>
                  {isLoadingMore ? (
                      <ImSpinner3 className="icon-spin" style={{ fontSize: 25 }} />
                  ) : (
                      "Load More"
                  )}
              </button>
            ) : (
              <div style={{
                  textAlign: 'center',
                  margin: '20px',
                  color: '#606060'
              }}>
                No More Properties to Load, refresh the page to fetch any newly added properties
              </div>
            )
          ) : null}
        </div>
      </div>
      }
    </>
  )
}

export default PropertyActivityGrid;
